import {
  InMemoryHeader,
  InMemoryString,
  InMemoryBoolean,
  InMemoryDate,
  InMemoryInteger,
  InMemoryDecimal,
  HeaderAlignment,
} from "pbas-vue-components";
import {
  translate
} from '../trans'
import store from '@/store'
import { translate2 } from '../trans2'
import { i18n } from '@/plugins/i18n';

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});

export default [
  new InMemoryHeader({
    title: "Id",
    type: new InMemoryString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
    version: 1,
  }),
  new InMemoryHeader({
    title: "headers.selfpayments.payment_date",
    type: new InMemoryDate("PaymentDate"),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    type: new InMemoryString("Term/Translations[]/LanguageCode"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new InMemoryHeader({
    title: "headers.selfpayments.plan_term",
    type: new InMemoryString("Term/Translations[]/Name", {
      getString: (item) => translate2(item.Term, "Name")
    }),
    sortable: true,
    visible: true,
    searchable: true,
    orderByKey: "Term/Name"
  }),
  new InMemoryHeader({
    title: "globals.amount",
    type: new InMemoryDecimal("Amount", {
      getString: (item, type) => {
        const value = item.Amount;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "headers.selfpayments.deposited",
    type: new InMemoryBoolean("Deposited"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  // new InMemoryHeader({
  //   type: new InMemoryDate("CreatedAt"),
  //   sortable: false,
  //   visible: false,
  //   searchable: false,
  //   allowVisibilityChange: false,
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryDate("ChangedAt"),
  //   sortable: false,
  //   visible: false,
  //   searchable: false,
  //   allowVisibilityChange: false,
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryDate("DeletedAt"),
  //   sortable: false,
  //   visible: false,
  //   searchable: false,
  //   allowVisibilityChange: false,
  // }),
];
